import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import {
  CurrencyValue,
  DataTable,
  useTableProps,
  RelativeDateTime,
  Box
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

function addSpaceToCamelCase(text) {
  // Replace uppercase letters with a space followed by the letter
  return text.replace(/([A-Z])/g, ' $1').trim();
}

export default function TransactionTable({ ilk }) {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-datetime'
  });
  const [data, error] = useApi({
    url: `/rwa/${ilk}/portfolio/document/transactions/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Action',
        getCell: (row) => addSpaceToCamelCase(row.type),
        columnSize: ['minmax(100px, auto)', 'minmax(150px, auto)']
      },
      {
        header: 'Amount',
        getCell: (row) => (
          <CurrencyValue
            value={row.amount}
            options={{ trend: true, currency: 'USD', iconSize: '0' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      //   {
      //     header: 'Liablity',
      //     getCell: (row) => <CurrencyValue value={row.liability} />,
      //     cellAlign: 'flex-end',
      //     headerAlign: 'flex-end'
      //   },
      //   {
      //     header: 'Asset Value',
      //     getCell: (row) => <CurrencyValue value={row.asset_value} />,
      //     cellAlign: 'flex-end',
      //     headerAlign: 'flex-end'
      //   },
      {
        header: 'Time',
        getCell: (row) => (
          <Box color="muted">
            <RelativeDateTime value={row.datetime} />
          </Box>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'datetime'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
